import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { KnowledgeTrainingContext } from "./KnowledgeTrainingContext";

export const useKnowledgeTraining = () => {
  const context = useContext(KnowledgeTrainingContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useKnowledgeTraining",
      "KnowledgeTrainingContext"
    );
  }

  return context;
};
